/**
 * PLUMO Image Assets
 * 
 * All product and editorial images in one place for easy swapping.
 * Replace URLs with your Flora AI generated images.
 */

// Shopify product URLs - maps product ID to Shopify page
export const SHOPIFY_URLS = {
  "1": "https://plumo-3123.myshopify.com/products/the-cuff-set-stackable-gold-ear-cuffs-no-piercing",
  "2": "https://plumo-3123.myshopify.com/products/the-layer-18k-gold-lariat-necklace",
  "3": "https://plumo-3123.myshopify.com/products/the-stack-gold-crystal-ring-set",
  "4": "https://plumo-3123.myshopify.com/products/the-bangle-gold-stainless-steel-cuff-set",
  "5": "https://plumo-3123.myshopify.com/products/the-drop",
  "6": "https://plumo-3123.myshopify.com/products/the-melt",
  "7": "https://plumo-3123.myshopify.com/products/the-signet",
  "8": "https://plumo-3123.myshopify.com/products/the-cuban",
  "lighter": "https://plumo-3123.myshopify.com/products/the-lighter",
  "watch": "https://plumo-3123.myshopify.com/products/the-watch",
  "bag": "https://plumo-3123.myshopify.com/products/the-bag",
  // Default fallback for any other products
  default: "https://plumo-3123.myshopify.com/products/the-cuff-set-stackable-gold-ear-cuffs-no-piercing"
};

// Helper to get Shopify URL by product ID
export const getShopifyUrl = (productId) => {
  return SHOPIFY_URLS[productId] || SHOPIFY_URLS.default;
};

export const IMAGES = {
  // ============ HERO & EDITORIAL ============
  hero: {
    main: "https://customer-assets.emergentagent.com/job_1fca014f-ddd8-451a-ad68-17c2161f13c0/artifacts/l2adx3sn_PLUMO_SHORT_V1_Image_15_2026-03-19_18-31.png",
  },
  
  editorial: {
    grid1: "https://customer-assets.emergentagent.com/job_1fca014f-ddd8-451a-ad68-17c2161f13c0/artifacts/gv8abvlv_Instagram%20post%20-%2017.png",
    grid2: "https://customer-assets.emergentagent.com/job_1fca014f-ddd8-451a-ad68-17c2161f13c0/artifacts/058gz45h_Insaasstagram%20post%20-%2078.png",
    grid3: "https://customer-assets.emergentagent.com/job_1fca014f-ddd8-451a-ad68-17c2161f13c0/artifacts/daja8h0h_Instagram%20post%20-%2027.png",
    about: "https://customer-assets.emergentagent.com/job_1fca014f-ddd8-451a-ad68-17c2161f13c0/artifacts/ncgimykl_Untitled_Fashion_Photography_Concept_1_2026-03-11_16-22.png",
  },

  // ============ PRODUCTS ============
  // Each product has a main image and optional gallery images
  products: {
    "1": {
      main: "https://customer-assets.emergentagent.com/job_editorial-jewelry/artifacts/8lsudtrz_Untitled_Gold_Ear_Cuff_Shot_1_2026-03-11_15-53.png",
      gallery: []
    },
    "2": {
      main: "https://customer-assets.emergentagent.com/job_editorial-jewelry/artifacts/ffyhloit_Untitled_Jewelry_Styling_Request_1_2026-03-11_15-28.png",
      gallery: []
    },
    "3": {
      main: "https://customer-assets.emergentagent.com/job_editorial-jewelry/artifacts/x8zxyu30_Untitled_Ringed_Hand_Edit_1_2026-03-11_17-00.png",
      gallery: []
    },
    "4": {
      main: "https://customer-assets.emergentagent.com/job_editorial-jewelry/artifacts/heh5vqrv_Untitled_Bangle_Fusion_Art_1_2026-03-11_15-28.png",
      gallery: []
    }
  }
};

// Helper to get product image by ID
export const getProductImage = (productId) => {
  return IMAGES.products[productId]?.main || IMAGES.products["1"].main;
};

// Helper to get product gallery by ID
export const getProductGallery = (productId) => {
  const product = IMAGES.products[productId];
  if (product?.gallery?.length > 0) {
    return product.gallery;
  }
  return [product?.main || IMAGES.products["1"].main];
};

export default IMAGES;
